angular.module('bmsApp.dashboard').controller('DashboardMarketingCtrl', function ($scope,
																				  $timeout,
																				  DashboardApiSvc,
																				  LicenseOptionsSvc,
																				  ngTableParams,
																				  InstanceSvc,
																				  $filter,
																				  $modal,
																				  MMCleaningFrequencySvc,
																				  SMCleaningServiceSvc) {

	$scope.metrics = {
		view:'local'
	};
	$scope.filters = {};
	$scope.options = {};

	MMCleaningFrequencySvc.options().then((response) => {
		$scope.options.cleaningFrequencies = response.data.options;
		$scope.options.cleaningFrequencies.unshift({
			id: 0,
			label: 'All Frequencies',
		});
		$scope.filters.cleaningFrequency = $scope.options.cleaningFrequencies[0];
	});

	SMCleaningServiceSvc.options().then((response) => {
		$scope.options.cleaningServices = response.data.cleaning_service_options;
		$scope.options.cleaningServices.unshift({
			id: 0,
			label: 'All Cleaning Services',
		});
		$scope.filters.cleaningService = $scope.options.cleaningServices[0];
	});

	$scope.cleaningFrequencyUpdated = () => {
		$scope.actions.loadInitiativeMetrics();
	};
	$scope.cleaningServiceUpdated = () => {
		$scope.actions.loadInitiativeMetrics();
	};

	angular.extend($scope.data, {
		customerStats: {
			active: null,
			lost: null,
			new: null,
			ytdRevenue: null,
			loaded: false,
		},
		revenue: {
			revenue: null,
			spend: null,
			loaded: true
		},
		marketingMetrics: {
			newEnquiries: null,
			newQuotes: null,
			newCustomers: null,
			enquiriesConverted: null,
			loaded: true
		},
		customerOverview: {
			activeCustomers: null,
			lostCustomers: null,
			newCustomers: null,
			loaded: false
		},
		marketingSummary: {
			activeCustomers: 0,
			lostCustomers: 0,
			newCustomers: 0,
			ytdRevenue: 0
		},
		marketingRevenue: {
			loaded: false
		},
		initiativeMetrics: {
			loaded: false
		},
		tilePopover: {
			open: function open(tileType) {
				var params = {
					tileType: tileType,
					filter: {
						fromDate: angular.copy($scope.data.dateRange.startDate),
						toDate: angular.copy($scope.data.dateRange.endDate),
						licenseId: angular.copy($scope.data.license.id)
					}
				};

				openTileBreakdownModal(params);
			},
			openRevenue: function openRevenue(tileType, initiativeId) {
				var params = {
					tileType: tileType,
					filter: {
						initiativeId: initiativeId,
						fromDate: angular.copy($scope.data.dateRange.startDate),
						toDate: angular.copy($scope.data.dateRange.endDate),
						licenseId: angular.copy($scope.data.license.id)
					}
				};

				openTileBreakdownModal(params);
			},
			close: function close() {
				$scope.data.tilePopover.isOpen = false;
			}
		}
	});

	function openTileBreakdownModal(params) {
		var modalInstance = $modal.open({
			animation: true,
			templateUrl: 'ng/dashboard/templates/DashboardTileBreakdown.html',
			controller: 'DashboardTileBreakdownCtrl',
			size: 'md',
			resolve: {
				params: function () {
					return params;
				}
			}
		});
	}


	$scope.$watchGroup(['data.license.id', 'data.dateRange.startDate', 'data.dateRange.endDate'], function (newValues) {
		//if (angular.isUndefined(newValues[0])){
			$scope.actions.updateAll();
		//}
	});

	angular.extend($scope.actions, {
		loadCustomerStats: function() {
			if (!$scope.data.customerStats.activeCustomers) {
				$scope.actions.updateCustomerStats();
			}
		},
		loadRevenue: function (chartObj) {
			$timeout(function () {
				if (chartObj) {
					chartObj.reflow();
				}
				if (!$scope.data.revenue.revenue) {
					$scope.actions.updateRevenue();
				}
			}, 50);
		},
		loadMarketingMetrics: function (chartObj) {
			$timeout(function () {
				if (chartObj) {
					chartObj.reflow();
				}
				if (!$scope.data.marketingMetrics.newEnquiries) {
					$scope.actions.updateMarketingMetrics();
				}
			}, 50);
		},
		loadCustomerOverview: function (chartObj) {
			$timeout(function () {
				if (chartObj) {
					chartObj.reflow();
				}
				if (!$scope.data.customerOverview.activeCustomers) {
					$scope.actions.updateCustomerOverview();
				}
			}, 50);
		},
		loadMarketingRevenue: function(){
			if (angular.isUndefined($scope.tableParamsMarketingRevenue)) {
				$scope.tableParamsMarketingRevenue = new ngTableParams(angular.extend({
					page: 0,
					sorting: {net: 'desc'},
					filter: {
						fromDate: angular.copy($scope.data.dateRange.startDate),
						toDate: angular.copy($scope.data.dateRange.endDate),
					}
				}), {
					total: 0, // length of data
					counts: null,
					getData: function ($defer, params) {
						if (true || !$scope.data.marketingRevenue.loaded) {

							DashboardApiSvc.marketingRevenue(params.$params).then(function (response) {
								$scope.forecastRevenue = response.data.report;
								$scope.totalForecastRevenue = response.data.totalForecast;
								$scope.data.marketingRevenue.loaded = true;
								$defer.resolve($filter('orderBy')($scope.forecastRevenue, params.orderBy()[0]));
							});
						}
						else{
							$defer.resolve($filter('orderBy')($scope.forecastRevenue, params.orderBy()[0]));
						}
					}
				});
			}
			else {
				angular.extend($scope.tableParamsMarketingRevenue.$params.filter, {
					licenseId: $scope.data.license ? $scope.data.license.id : 0,
					fromDate: angular.copy($scope.data.dateRange.startDate),
					toDate: angular.copy($scope.data.dateRange.endDate),
				});
				$scope.data.marketingRevenue.loaded = false;
			}
		},
		loadInitiativeMetrics: function(){

			$scope.initiativeMetricsLoading = true;
			let params = {
				filter: {
					from: $scope.data.dateRange.startDate,
					to: $scope.data.dateRange.endDate,
					franchise: {
						id: InstanceSvc.instance.getFranchiseId(),
					},
					mmCleaningFrequency: {
						id: angular.isObject($scope.filters.cleaningFrequency) && $scope.filters.cleaningFrequency.id !== 0 ? $scope.filters.cleaningFrequency.id : null,
					},
					smCleaningService: {
						id: angular.isObject($scope.filters.cleaningService) && $scope.filters.cleaningService.id !== 0 ? $scope.filters.cleaningService.id : null,
					},
					view: $scope.metrics.view,
					api_key: InstanceSvc.instance.getFranchiseApiKey(),
				},
			};

			if ($scope.data.license.id !== 0) {
				angular.extend(params.filter, {
					licenses: [
						{
							id: $scope.data.license.id
						}
					]
				});
			}

			DashboardApiSvc.initiativeMetrics(params).then((response) => {
				$scope.initiativeMetrics = response.data.initiative_collection;
				$scope.initiativeMetricsLoading = false;
			});

		},
		updateAll: function () {
			updateChartData(['revenue', 'marketingMetrics', 'customerOverview', 'customerStats']);

			$scope.actions.loadMarketingRevenue();
			$scope.actions.loadInitiativeMetrics();
		},
		updateRevenue: function () {
			updateChartData(['revenue']);
		},
		updateMarketingMetrics: function () {
			updateChartData(['marketingMetrics']);
		},
		updateCustomerOverview: function () {
			updateChartData(['customerOverview']);
		},
		updateCustomerStats: function() {
			updateChartData(['customerStats']);
		}
	});

	function updateChartData(types) {
		types.push('marketingSummary'); // refresh this every time
		types.push('customerStats'); // refresh this every time
		$scope.actions.applyFilter();
		if ($scope.data.loading === false && $scope.data.updating === false) {
			$scope.data.updating = true;
			DashboardApiSvc
				.chart({
					types: types,
					dateRange: $scope.data.dateRange,
					licenseId: $scope.data.license ? $scope.data.license.id : null
				})
				.then(function (response) {

					if (types.indexOf('customerStats') > -1) {

						angular.extend($scope.data.customerStats, angular.copy(response.data.customerStats[0]));
					}
					if (types.indexOf('marketingMetrics') > -1) {
						$scope.charts.marketingMetrics = angular.copy($scope.chartTemplates.marketingMetrics);
						$scope.charts.marketingMetrics.loading = false;
						$scope.charts.marketingMetrics.xAxis.categories = response.data.categories;
						$scope.data.marketingMetrics.newEnquiries = response.data.marketingMetrics.newEnquiries;
						$scope.data.marketingMetrics.newQuotes = response.data.marketingMetrics.newQuotes;
						$scope.data.marketingMetrics.newCustomers = response.data.marketingMetrics.newCustomers;
						$scope.data.marketingMetrics.enquiriesConverted = response.data.marketingMetrics.enquiriesConverted;
						$scope.data.marketingMetrics.loaded = true;
						$scope.charts.marketingMetrics.series[0].data = response.data.marketingMetrics.newEnquiries.data;
						$scope.charts.marketingMetrics.series[1].data = response.data.marketingMetrics.newQuotes.data;
						$scope.charts.marketingMetrics.series[2].data = response.data.marketingMetrics.newCustomers.data;
						$scope.charts.marketingMetrics.series[3].data = response.data.marketingMetrics.enquiriesConverted.data;
					}
					if (types.indexOf('revenue') > -1) {
						$scope.charts.revenue = angular.copy($scope.chartTemplates.revenue);
						$scope.charts.revenue.loading = false;
						$scope.charts.revenue.xAxis.categories = response.data.categories;
						$scope.data.revenue.revenue = response.data.revenue.revenue;
						$scope.data.revenue.loaded = true;
						$scope.charts.revenue.series[0].data = response.data.revenue.revenue.data;
						$scope.charts.revenue.series[1].data = response.data.revenue.revenue.spend;
					}
					if (types.indexOf('customerOverview') > -1) {
						$scope.charts.customerOverview = angular.copy($scope.chartTemplates.customerOverview);
						$scope.charts.customerOverview.loading = false;
						$scope.charts.customerOverview.xAxis.categories = response.data.categories;
						$scope.data.customerOverview.activeCustomers = response.data.customerOverview.activeCustomers;
						if (!$scope.isSM()) {
							$scope.data.customerOverview.lostCustomers = response.data.customerOverview.lostCustomers;
						}
						
						$scope.data.customerOverview.newCustomers = response.data.customerOverview.newCustomers;
						$scope.data.customerOverview.loaded = true;
						$scope.charts.customerOverview.series[0].data = response.data.customerOverview.activeCustomers.data;
						if (!$scope.isSM()) {
							$scope.charts.customerOverview.series[1].data = response.data.customerOverview.lostCustomers.data;
						}
						$scope.charts.customerOverview.series[2].data = response.data.customerOverview.newCustomers.data;
					}
					$scope.data.updating = false;
				});
		}
	}

	// Chart configs -----------------------------------------------------------------------------------------------
	$scope.chartTemplates = {
		revenue: {
			chart: {
				type: 'spline'
			},
			plotOptions: {
				series: {
					stacking: ''
				}
			},
			tooltip: {
				formatter: function () {
					var tooltip, values;
					tooltip = '<span style="color:' + this.series.color + '">' + this.series.name + ' breakdown</span>:<br/>';
					if (this.series.index == 0) {
						values = $scope.data.revenue.revenue.breakdown[this.point.index];
					}
					else if (this.series.index == 1) {
						values = $scope.data.revenue.revenue.spend_breakdown[this.point.index];
					}

					angular.forEach(values, function (value) {
						tooltip += value + '<br/>';
					});
					return tooltip;
				},
				crosshairs: [true, true],
				useHTML: true
			},
			series: [
				{
					name: 'Revenue',
					connectNulls: true,
					data: []
				},
				{
					name: 'Spend',
					connectNulls: true,
					data: []
				}
			],
			title: {
				text: 'Revenue'
			},
			credits: {
				enabled: false
			},
			loading: true,
			size: {},
			xAxis: {
				allowDecimals: false,
				title: {
					text: ''
				},
				categories: []
			},
			yAxis: {
				min: 0,
				allowDecimals: false,
				title: {
					text: '£'
				}
			}
		},
		marketingMetrics: {
			chart: {
				type: 'spline'
			},
			plotOptions: {
				series: {
					stacking: ''
				}
			},
			tooltip: {
				formatter: function () {
					var tooltip;
					tooltip = '<span style="color:' + this.series.color + '">' + this.series.name + ' breakdown</span>:<br/>';
					var values;
					if (this.series.index == 0) {
						values = $scope.data.marketingMetrics.newEnquiries.breakdown[this.point.index];
					}
					else if (this.series.index == 1) {
						values = $scope.data.marketingMetrics.newQuotes.breakdown[this.point.index];
					}
					else if (this.series.index == 2) {
						values = $scope.data.marketingMetrics.newCustomers.breakdown[this.point.index];
					}
					else if (this.series.index == 3) {
						values = $scope.data.marketingMetrics.enquiriesConverted.breakdown[this.point.index];
					}
					angular.forEach(values, function (value) {
						tooltip += value + '<br/>';
					});
					return tooltip;
				},
				crosshairs: [true, false],
				useHTML: true
			},
			series: [
				{
					name: 'New Enquires',
					connectNulls: true,
					data: []
				},
				{
					name: 'New Quotes',
					connectNulls: true,
					data: []
				},
				{
					name: 'New Customers',
					connectNulls: true,
					data: []
				},
				{
					name: 'Enquiries Converted',
					connectNulls: true,
					data: []
				}
			],
			title: {
				text: 'Marketing Metrics'
			},
			credits: {
				enabled: false
			},
			loading: true,
			size: {},
			xAxis: {
				allowDecimals: false,
				title: {
					text: ''
				},
				categories: []
			},
			yAxis: {
				min: 0,
				allowDecimals: false
			}
		},
		customerOverview: {
			chart: {
				type: 'spline'
			},
			plotOptions: {
				series: {
					stacking: ''
				}
			},
			series: [
				{
					name: 'Active Customers',
					connectNulls: true,
					data: [],
					zIndex: 4,
					yAxis: 0
				},
				{
					name: 'Lost Customers',
					connectNulls: true,
					data: [],
					yAxis: 1
				},
				{
					name: 'New Customers',
					connectNulls: true,
					data: [],
					yAxis: 1
				}
			],
			title: {
				text: 'Customer Overview'
			},
			credits: {
				enabled: false
			},
			loading: true,
			size: {},
			xAxis: {
				allowDecimals: false,
				title: {
					text: ''
				},
				categories: []
			},
			yAxis: [
				{
					min: 0,
					allowDecimals: false,
					title: {
						text: 'Customers (Active)'
					}
				},
				{
					min: 0,
					allowDecimals: false,
					title: {
						text: 'Customers (New & Lost)'
					},
					opposite: true
				}
			]
		}
	};

	// Initialised charts ------------------------------------------------------------------------------------------
	$scope.charts = {};
	$scope.chartObjs = {};

});
